module.exports = __webpack_public_path__ + "static/arrow.up.transparent-e9dc5c33d14b2510217e9686e1d4ac32.png";